import { cn } from "@/lib/utils";

/**
 * BrandMark — logo + wordmark.
 * @param {boolean}  tagline - show "ERP Platform" sub-label
 * @param {boolean}  collapsed - sidebar collapsed state (show icon only)
 * @param {'light'|'dark'} variant - 'dark' for use on Charcoal/dark bg (default), 'light' for white bg
 */
export function BrandMark({ tagline = true, collapsed = false, variant = "dark" }) {
  const isDark = variant === "dark";
  return (
    <div className="inline-flex items-center gap-2.5" data-testid="brand-mark">
      <img src="/brand/buildnexa-icon.png" alt="buildnexa.io" className="h-8 w-8 shrink-0 object-contain" />
      {!collapsed && (
        <div>
          <div className={cn(
            "text-[14px] font-bold leading-none tracking-tight",
            isDark ? "text-[#ECF4F7]" : "text-[#393F4B]"
          )}>
            buildnexa
            <span className={isDark ? "text-[#C4587B]" : "text-[#910029]"}>.io</span>
          </div>
          {tagline && (
            <div className={cn(
              "mt-1 text-[8px] font-semibold uppercase tracking-[0.22em]",
              isDark ? "text-[#8B9BB8]" : "text-[#6B7A8D]"
            )}>
              ERP Platform
            </div>
          )}
        </div>
      )}
    </div>
  );
}
